<lms-breadcrumb></lms-breadcrumb>
<div class="gl-reports__title">{{ 'reports.type' | translate }}</div>
<div class="gl-reports__containerCards">
  <div class="gl-reports__cards">
    <div *lmsProfileGuard="'reports.licenses'" class="gl-reports__cards--item">
      <div class="title">
        <span class="glicon-file-report"></span>
        <span>{{ 'licenses.label' | translate }}</span>
      </div>
      <div class="text">{{ 'reports.cards.licensesDescription' | translate }}</div>
      <div class="actions">
        <gl-button
          [routerLink]="['/reports/licenses']"
          color-secondary
          [text]="'nouns.viewReports' | translate"
        ></gl-button>
      </div>
    </div>

    <div *lmsProfileGuard="'reports.groups'" class="gl-reports__cards--item">
      <div class="title">
        <span class="glicon-file-report"></span>
        <span>{{ 'groups.label' | translate }}</span>
      </div>
      <div class="text">{{ 'reports.cards.groupsDescription' | translate }}</div>
      <div class="actions">
        <gl-button
          [routerLink]="['/reports/groups']"
          color-secondary
          [text]="'nouns.viewReports' | translate"
        ></gl-button>
      </div>
    </div>

    <div *lmsProfileGuard="'reports.students'" class="gl-reports__cards--item">
      <div class="title">
        <span class="glicon-file-report"></span>
        <span>{{ 'students.label' | translate }}</span>
      </div>
      <div class="text">{{ 'reports.cards.studentsDescription' | translate }}</div>
      <div class="actions">
        <gl-button
          [routerLink]="['/reports/students']"
          color-secondary
          [text]="'nouns.viewReports' | translate"
        ></gl-button>
      </div>
    </div>

    <div *lmsProfileGuard="'reports.surveys'" class="gl-reports__cards--item">
      <div class="title">
        <span class="glicon-file-survey"></span>
        <span>{{ 'surveys.label' | translate }}</span>
      </div>
      <div class="text">{{ 'reports.cards.surveysDescription' | translate }}</div>
      <div class="actions">
        <gl-button
          [routerLink]="['/reports/surveys']"
          color-secondary
          [text]="'nouns.viewReports' | translate"
        ></gl-button>
      </div>
    </div>

    <div *lmsProfileGuard="'reports.activity'" class="gl-reports__cards--item">
      <div class="title">
        <span class="glicon-activity"></span>
        <span>{{ 'reports.activity.label' | translate }}</span>
      </div>
      <div class="text">{{ 'reports.cards.activityDescription' | translate }}</div>
      <div class="actions">
        <gl-button
          [routerLink]="['/reports/activity']"
          color-secondary
          [text]="'nouns.viewReports' | translate"
        ></gl-button>
      </div>
    </div>

    <div *lmsProfileGuard="'reports.events'" class="gl-reports__cards--item">
      <div class="title">
        <span class="glicon-file-event-list"></span>
        <span>{{ 'reports.events.label' | translate }}</span>
      </div>
      <div class="text">{{ 'reports.cards.eventsDescription' | translate }}</div>
      <div class="actions">
        <gl-button
          [routerLink]="['/reports/events']"
          color-secondary
          [text]="'nouns.viewReports' | translate"
        ></gl-button>
      </div>
    </div>
  </div>
</div>
<div class="gl-reports__title tableType">{{ 'reports.myReports' | translate }}</div>
<gl-personalizations-report
  (sendReport)="sendReport($event)"
  (viewReport)="viewReport($event.detail.report)"
></gl-personalizations-report>
